
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Innovacrystaonrentinpune() {



  const cardData =
  {
    keyword: 'Innova Crysta on Rent in Pimpri Chinchwad',
    heading: 'SHREE Tours & Travels: Innova Crysta on Rent in Pimpri Chinchwad   ',
    headingDescription: 'SHREE Tours & Travels offers Innova Crysta on rent in Pimpri Chinchwad, providing a luxurious and spacious travel experience for families, corporate trips and outstation journeys. Whether you need a Cab for one-way travel, round trips, airport transfers, or weekend getaways, our well-maintained Innova Crysta ensures a smooth, comfortable and hassle-free ride. With professional drivers, ample luggage space and affordable pricing, we guarantee a premium travel experience. Choose SHREE Tours & Travels for the best Innova Crysta rental service in Pimpri Chinchwad.',

    top: 'Top Places to Visit in Pimpri Chinchwad with SHREE Tours & Travels',
"topPlaces": [
    {
        "title": "Auto Cluster Exhibition Center",
        "description": "A hub for automobile enthusiasts and industrial expos, the Auto Cluster Exhibition Center in Pimpri-Chinchwad hosts various exhibitions, trade fairs and automotive events. It provides insights into the latest technologies in the automobile and manufacturing sectors, making it a must-visit for industry professionals and car lovers."
    },
    {
        "title": "Morya Gosavi Ganpati Temple",
        "description": "One of the most revered temples in Pimpri-Chinchwad, the Morya Gosavi Ganpati Temple is dedicated to Lord Ganesha. The temple has historical significance as it is associated with Saint Morya Gosavi, a great devotee of Lord Ganesha. Devotees visit this peaceful temple to seek blessings and experience spiritual tranquility."
    },
    {
        "title": "Appu Ghar Amusement Park",
        "description": "A fun-filled amusement park for families and children, Appu Ghar features exciting rides, a toy train and water attractions. Nicknamed ‘Mini Disneyland of Pune,’ the park is a great place for a weekend getaway, offering thrilling entertainment and recreational activities for all age groups."
    },
    {
        "title": "Durga Tekdi",
        "description": "Durga Tekdi is a popular green space ideal for morning walks, jogging and picnics. The hill provides scenic views of the city and a refreshing natural environment, making it a favorite spot for fitness enthusiasts and nature lovers. The area is also home to diverse flora and fauna, adding to its charm."
    },
    {
        "title": "Bhakti Shakti Garden",
        "description": "Bhakti Shakti Garden is a well-maintained public park featuring the grand statue of Chhatrapati Shivaji Maharaj and Sant Tukaram. It serves as a recreational space where visitors can enjoy peaceful strolls, exercise and relax amidst greenery. The garden is beautifully lit in the evening, making it an ideal spot for families."
    },
    {
        "title": "Bird Valley Udyan",
        "description": "Bird Valley Udyan is a picturesque park featuring a large lake, jogging tracks and a children's play area. It is a great place for birdwatching, especially in the early mornings when various migratory birds can be spotted. The serene environment makes it perfect for relaxation and leisure activities."
    },
    {
        "title": "Science Park",
        "description": "A must-visit for students and science enthusiasts, Science Park in Pimpri-Chinchwad offers interactive exhibits, planetarium shows and educational activities. The park makes learning fun with hands-on experiments and demonstrations that cover various scientific principles and innovations."
    },
    {
        "title": "Gahunje Cricket Stadium (MCA Stadium)",
        "description": "The Maharashtra Cricket Association Stadium, located near Pimpri-Chinchwad, is a state-of-the-art cricket ground hosting IPL matches and international games. Cricket lovers can experience thrilling live matches and cheer for their favorite teams in this modern sports facility."
    },
    {
        "title": "Nisargakavi Bahinabai Chaudhary Zoo",
        "description": "A small but well-maintained zoo, this place is ideal for kids and families. It houses various animals, birds and reptiles, offering an opportunity for visitors to learn about wildlife conservation. The zoo is surrounded by lush greenery, making it a pleasant visit."
    },
    {
        "title": "Chinchwad Railway Museum",
        "description": "This unique museum showcases the evolution of Indian Railways through models, artifacts and vintage locomotives. It provides an educational experience for history buffs and railway enthusiasts, offering insights into the country’s railway heritage and engineering marvels."
    }
],  
    
            
"services": [
    {
      "name": "Innova Crysta Rental Pimpri Chinchwad",
      "description": "Rent an Innova Crysta in Pimpri Chinchwad for a comfortable and luxurious ride. Known for its spacious and premium interiors, this vehicle is ideal for both family trips and corporate travel, ensuring a smooth and enjoyable journey."
    },
    {
      "name": "Rent Innova Crysta Pimpri Chinchwad",
      "description": "Book an Innova Crysta in Pimpri Chinchwad for any travel need. Whether it’s a family vacation, group tour, or a corporate trip, enjoy a comfortable ride with spacious seating, modern amenities and reliable service."
    },
    {
      "name": "Affordable Innova Crysta Hire Pimpri Chinchwad",
      "description": "Looking for a budget-friendly yet luxurious ride? Rent an affordable Innova Crysta for your trips from Pimpri Chinchwad. Experience comfort and style without breaking the bank."
    },
    {
      "name": "Book Innova Crysta for Family Travel Pimpri Chinchwad",
      "description": "Plan a memorable family trip by renting an Innova Crysta from Pimpri Chinchwad. With ample space for luggage and passengers, it’s the perfect vehicle for family outings, vacations, or long-distance travel."
    },
    {
      "name": "Innova Crysta for Outstation Pimpri Chinchwad",
      "description": "Travel to outstation destinations in style with an Innova Crysta rental from Pimpri Chinchwad. Perfect for long journeys, this car offers a smooth, comfortable ride with ample space for your family or group."
    },
    {
      "name": "Luxury Innova Crysta Rental Pimpri Chinchwad",
      "description": "Experience luxury on the road with an Innova Crysta rental in Pimpri Chinchwad. This premium vehicle is equipped with modern amenities and ensures a smooth, comfortable ride, perfect for both business and leisure trips."
    },
    {
      "name": "Private Innova Crysta for Pimpri Chinchwad to Outstation",
      "description": "Book a private Innova Crysta for your outstation trips from Pimpri Chinchwad. With its spacious interiors and luxury features, it’s the perfect choice for a hassle-free and relaxing travel experience."
    },
    {
      "name": "Group Travel in Innova Crysta Pimpri Chinchwad",
      "description": "Travel with your friends or colleagues in comfort with an Innova Crysta for group travel from Pimpri Chinchwad. The vehicle’s generous seating and luggage space make it ideal for group outings, tours and more."
    },
    {
      "name": "Rent Innova Crysta for Corporate Travel Pimpri Chinchwad",
      "description": "For corporate trips, rent an Innova Crysta in Pimpri Chinchwad. With its spacious interiors and executive feel, it’s the perfect vehicle for business meetings, client travel, or company retreats."
    },
    {
      "name": "Innova Crysta for Airport Pickup Pimpri Chinchwad",
      "description": "Book an Innova Crysta for a convenient and comfortable airport pickup from Pimpri Chinchwad. Enjoy a smooth ride with a professional driver who will ensure timely arrivals and departures."
    },
    {
      "name": "Innova Crysta Hire for Business Trip Pimpri Chinchwad",
      "description": "Make your business trip even more comfortable by renting an Innova Crysta in Pimpri Chinchwad. With ample space for work and relaxation, this car is perfect for professionals traveling for meetings or conferences."
    }
  ],
  "tableData": [
    ["- Innova Crysta Rental Pimpri Chinchwad", "- Rent Innova Crysta Pimpri Chinchwad"],
    ["- Affordable Innova Crysta Hire Pimpri Chinchwad", "- Book Innova Crysta for Family Travel Pimpri Chinchwad"],
    ["- Innova Crysta for Outstation Pimpri Chinchwad", "- Luxury Innova Crysta Rental Pimpri Chinchwad"],
    ["- Private Innova Crysta for Pimpri Chinchwad to Outstation", "- Group Travel in Innova Crysta Pimpri Chinchwad"],
    ["- Rent Innova Crysta for Corporate Travel Pimpri Chinchwad", "- Innova Crysta for Airport Pickup Pimpri Chinchwad"],
    ["- Innova Crysta Hire for Business Trip Pimpri Chinchwad"]
  ],

  whychoose: [
    {
      "WhyChooseheading": "Premium Comfort and Style",
      "WhyChoosedescription": "The Toyota Innova Crysta is the epitome of luxury, offering premium comfort, sleek design and top-notch performance. With its spacious interior, modern amenities and powerful engine, the Innova Crysta provides a superior travel experience for both short and long journeys in Pimpri Chinchwad."
    },
    {
      "WhyChooseheading": "Perfect for Family and Group Travel",
      "WhyChoosedescription": "With seating for up to 7 passengers, the Innova Crysta is an ideal choice for families or groups. Whether you're planning a family vacation, a corporate trip, or a weekend getaway, this versatile vehicle offers ample space and comfort for everyone, ensuring a pleasant ride throughout the journey."
    },
    {
      "WhyChooseheading": "Well-Maintained and Safe Vehicles",
      "WhyChoosedescription": "We ensure that all our Innova Crysta vehicles are meticulously maintained and regularly serviced for optimal performance. Our vehicles undergo thorough inspections for cleanliness, safety and mechanical reliability, giving you peace of mind knowing you're traveling in a safe and well-maintained vehicle."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and professional, ensuring you enjoy a smooth, safe and comfortable ride. They are familiar with the best routes around Pimpri Chinchwad and beyond and they focus on punctuality, safety and customer satisfaction, making your trip enjoyable and stress-free."
    },
    {
      "WhyChooseheading": "Ideal for Business and Leisure Travel",
      "WhyChoosedescription": "The Innova Crysta is perfect for both business and leisure travel. Whether you're attending a corporate meeting, traveling for a special event, or going on a family vacation, the Innova Crysta offers the perfect combination of luxury and practicality to suit your needs."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking the Innova Crysta with SHREE Tours & Travels is quick and easy. You can make your reservation online through our user-friendly platform, or you can reach out to our customer service team for personalized assistance. We ensure a seamless and convenient booking experience."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for Innova Crysta rentals in Pimpri Chinchwad. Whether it's a last-minute booking or a planned trip, we’re ready to accommodate your travel needs anytime, day or night, ensuring you have access to a comfortable and reliable vehicle whenever you need it."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we prioritize customer satisfaction. We are dedicated to providing exceptional service, ensuring that every Innova Crysta rental meets the highest standards of comfort, safety and reliability. Our goal is to provide you with a smooth and enjoyable experience from start to finish."
    }
  ]
  

  
  
  
  
  

  
  



        
  }
  const faqData = [
    {
        question: "How can I rent an Innova Crysta in Pimpri Chinchwad?",
        answer: "You can easily rent an Innova Crysta in Pimpri Chinchwad through our website or by contacting our customer service for assistance."
    },
    {
        question: "What is the rental rate for an Innova Crysta in Pimpri Chinchwad?",
        answer: "The rental rate for an Innova Crysta varies depending on the duration and type of trip. Please contact us for detailed pricing information."
    },
    {
        question: "Is the rental rate for the Innova Crysta inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. We provide detailed pricing information during the booking process."
    },
    {
        question: "Can I rent an Innova Crysta for a one-way trip in Pimpri Chinchwad?",
        answer: "Yes, we offer one-way rental options for the Innova Crysta for trips within Pimpri Chinchwad or to nearby cities."
    },
    {
        question: "Do you provide drivers with the Innova Crysta rental in Pimpri Chinchwad?",
        answer: "Yes, all our Innova Crysta rentals come with experienced drivers who are familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for Innova Crysta bookings in Pimpri Chinchwad?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for renting an Innova Crysta in Pimpri Chinchwad?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the Innova Crysta vehicles insured for safety during trips in Pimpri Chinchwad?",
        answer: "Yes, all our Innova Crysta vehicles are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my Innova Crysta rental in Pimpri Chinchwad?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for renting an Innova Crysta in Pimpri Chinchwad?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I rented an Innova Crysta from SHREE Tours & Travels for a family trip in Pimpri Chinchwad. The vehicle was luxurious, spacious and the driver was very professional and courteous.',
        name: 'Mr. Rajesh Patil',
    },
    {
        text: 'SHREE Tours & Travels provided an excellent Innova Crysta rental service. The car was well-maintained and comfortable for our long journey. The driver ensured a smooth and safe trip.',
        name: 'Miss. Aishwarya Deshmukh',
    }
];
















  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Rent an Innova Crysta for your travel needs in Pimpri Chinchwad. Offering affordable and luxury rental options for outstation trips, group travel, family trips, corporate travel and airport pickups. Call +91 9594917913 to book your Innova Crysta today!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pimpri Chinchwad",
    "addressRegion": "Maharashtra",
    "postalCode": "411017",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/innova-crysta-pimpri-chinchwad.jpg",
    "https://shreetoursandtravels.in/img/innova-crysta-group-travel.jpg"
  ],
  "priceRange": "₹8000 - ₹15000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/innova-crysta-pimpri-chinchwad",
    "priceCurrency": "INR",
    "price": 9000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.9,
    "reviewCount": 950
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Suresh Patil"
      },
      "datePublished": "2024-10-12",
      "reviewBody": "The Innova Crysta was perfect for our family trip to Mahabaleshwar. Comfortable and spacious, with an excellent driver. Highly recommended!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Priya Sharma"
      },
      "datePublished": "2024-11-05",
      "reviewBody": "Booked Innova Crysta for a corporate trip. The vehicle was clean, well-maintained and the driver was punctual. Made the trip hassle-free."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Innova Crysta Rental in Pimpri Chinchwad",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.6280,  // Pimpri Chinchwad latitude
      "longitude": 73.8044  // Pimpri Chinchwad longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/innova-crysta-pimpri-chinchwad"
  },
  "keywords": "Innova Crysta Rental Pimpri Chinchwad, Rent Innova Crysta Pimpri Chinchwad, Affordable Innova Crysta Hire Pimpri Chinchwad, Book Innova Crysta for Family Travel Pimpri Chinchwad, Innova Crysta for Outstation Pimpri Chinchwad, Luxury Innova Crysta Rental Pimpri Chinchwad, Private Innova Crysta for Pimpri Chinchwad to Outstation, Group Travel in Innova Crysta Pimpri Chinchwad, Rent Innova Crysta for Corporate Travel Pimpri Chinchwad, Innova Crysta for Airport Pickup Pimpri Chinchwad, Innova Crysta Hire for Business Trip Pimpri Chinchwad"
};


  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Innova Crysta on Rent in Pimpri Chinchwad | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent an Innova Crysta for your travel needs in Pimpri Chinchwad. Offering affordable and luxury rental options for outstation trips, group travel, family trips, corporate travel and airport pickups. Call +91 9594917913 to book your Innova Crysta today!" />
  <meta name="keywords" content="Innova Crysta Rental Pimpri Chinchwad, Rent Innova Crysta Pimpri Chinchwad, Affordable Innova Crysta Hire Pimpri Chinchwad, Book Innova Crysta for Family Travel Pimpri Chinchwad, Innova Crysta for Outstation Pimpri Chinchwad, Luxury Innova Crysta Rental Pimpri Chinchwad, Private Innova Crysta for Pimpri Chinchwad to Outstation, Group Travel in Innova Crysta Pimpri Chinchwad, Rent Innova Crysta for Corporate Travel Pimpri Chinchwad, Innova Crysta for Airport Pickup Pimpri Chinchwad, Innova Crysta Hire for Business Trip Pimpri Chinchwad" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>


    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/28.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Innovacrystaonrentinpune;